import WidgetsOutlined from '@mui/icons-material/WidgetsOutlined';
import { CaptivePortalIcon } from '@openx/components-core/icons/CaptivePortalIcon/CaptivePortalIcon';
import { PackageFields } from '@openx/types/package';
import { TargetingFields } from '@openx/types/targeting/targeting';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { type Section, TargetingElementKeys, type TargetingElementKeysType } from '../../context/types';
import { convertApiToSet } from '../../utils/convertApiToSet';
import { useTargetingSelectionActions } from '../useTargetingSelectionActions';

export const useChannelInitialState = (): Section => {
  const { t } = useTranslation();
  const { toggleElementSelection } = useTargetingSelectionActions();
  const { getValues } = useFormContext() || { getValues: () => null };

  return useMemo(() => {
    const initFormat = getValues(`${PackageFields.TARGETING}.${TargetingFields.INVENTORY_FORMAT}.ad_placement.val`);
    const formValue = getValues(
      `${PackageFields.TARGETING}.${TargetingFields.INVENTORY_FORMAT}.distribution_channel.val`
    );
    const initValues = convertApiToSet(formValue);
    const isSelected = (key: TargetingElementKeysType): boolean => initValues.has(key);

    return {
      label: t('Channel'),
      isLoading: true,
      elements: [
        {
          mainOption: {
            key: TargetingElementKeys.CHANNEL_WEB,
            icon: <CaptivePortalIcon />,
            label: t('Web'),
            isSelected: isSelected(TargetingElementKeys.CHANNEL_WEB),
            isDisabled: initFormat === TargetingElementKeys.FORMAT_CTV || !initValues.size,
            onClick: (_event, sectionKey, elementIndex) => {
              toggleElementSelection(sectionKey, elementIndex);
            },
          },
        },
        {
          mainOption: {
            key: TargetingElementKeys.CHANNEL_APP,
            label: t('App'),
            icon: <WidgetsOutlined />,
            isSelected: isSelected(TargetingElementKeys.CHANNEL_APP),
            isDisabled: !initValues.size,
            onClick: (_event, sectionKey, elementIndex) => {
              toggleElementSelection(sectionKey, elementIndex);
            },
          },
        },
      ],
    };
  }, [t, toggleElementSelection, getValues]);
};
